export default "__VITE_ASSET__BOyz8wc4__"